import {ChallengeSuggestion} from '@/models/challenge-suggestion.model';
import {BaseApi} from '@/api/base.api';

export class ChallengeSuggestionsApi extends BaseApi<ChallengeSuggestion> {
  constructor() {
    super('challenge-suggestions')
  }
}
